import { gql } from '@apollo/client'

export const GET_CREDIT_LINES_LIST = gql`
  {
    allocated
    advanceRate
    available
    balance
    businessproductid
    buyer
    currency
    customer {
      id
      address
    }
    duration
    expires_at
    gracePeriod
    grossRate
    id
    interestRatePerPeriod
    lateFeeMultiplier
    maxDays
    maxValue
    overdraft
    status
  }
`
